import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  LayoutDashboard,
  Newspaper,
  FolderTree,
  Tags,
  MessageSquare,
  GalleryVerticalEnd,
  Image,
  Users,
  Mail,
  PhoneCall,
  SearchCheck,
  LogOut,
  Building2,
  ShieldCheck, 
  Handshake,
  
} from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const links = [
  { label: "Dashboard", path: "/admin", icon: LayoutDashboard },
  { label: "Posts", path: "/admin/posts", icon: Newspaper },
  { label: "Categories", path: "/admin/categories", icon: FolderTree },
  { label: "Tags", path: "/admin/tags", icon: Tags },
  { label: "Comments", path: "/admin/comments", icon: MessageSquare },
  { label: "Media", path: "/admin/media", icon: Image },
  { label: "Gallery", path: "/admin/gallery", icon: GalleryVerticalEnd },
  { label: "Projects", path: "/admin/projects", icon: Building2 },
  { label: "Complaints", path: "/admin/complaints", icon: ShieldCheck },
  { label: "Partnerships", path: "/admin/partnerships", icon: Handshake },
  { label: "Newsletter", path: "/admin/newsletter", icon: Mail },
  { label: "Contacts", path: "/admin/contacts", icon: PhoneCall },
  { label: "Users", path: "/admin/users", icon: Users },
  { label: "SEO Settings", path: "/admin/seo", icon: SearchCheck },
];

const AdminLayout = () => {
  const { admin, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/admin-signin");
  };

  return (
    <div className="min-h-screen bg-slate-100 flex">
      <aside className="hidden lg:flex w-[290px] bg-[#04160a] text-white flex-col fixed inset-y-0 left-0 z-40">
        <div className="p-6 border-b border-white/10">
          <img
            src="/assets/images/logo.png"
            alt="Logo"
            className="w-16 h-16 object-contain mb-3"
          />

          <h2 className="font-black leading-tight text-xl">
            AKSUBEB CMS
          </h2>

          <p className="text-xs text-white/60 mt-1">
            {admin?.role?.toUpperCase()}
          </p>
        </div>

        <nav className="flex-1 px-4 py-6 space-y-2 overflow-y-auto">
          {links.map(({ label, path, icon: Icon }) => (
            <NavLink
              key={label}
              to={path}
              end={path === "/admin"}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 rounded-2xl font-semibold transition-all ${
                  isActive
                    ? "bg-[#ff6600] text-white"
                    : "text-white/75 hover:bg-white/10 hover:text-white"
                }`
              }
            >
              <Icon size={18} />
              {label}
            </NavLink>
          ))}
        </nav>

        <button
          onClick={handleLogout}
          className="m-4 px-4 py-3 rounded-2xl bg-white/10 hover:bg-[#ff6600] flex items-center gap-3 font-bold"
        >
          <LogOut size={18} />
          Logout
        </button>
      </aside>

      <div className="flex-1 lg:ml-[290px]">
        <header className="sticky top-0 z-30 bg-white border-b px-6 py-4 flex justify-between items-center">
          <div>
            <h1 className="font-black text-[#0b6b1d]">
              Admin Dashboard
            </h1>
            <p className="text-xs text-slate-500">
              Welcome, {admin?.name}
            </p>
          </div>

          <button
            onClick={handleLogout}
            className="lg:hidden px-4 py-2 rounded-xl bg-[#04160a] text-white"
          >
            Logout
          </button>
        </header>

        <main className="p-4 md:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;